function accountForgotPassword(){
  function showRecoverPasswordForm(){
    $('#RecoverPasswordForm').show();
    $('#CustomerLoginForm').hide();
  }

  function hideRecoverPasswordForm(){
    $('#RecoverPasswordForm').hide();
    $('#CustomerLoginForm').show();
  }

  $('#RecoverPassword').on('click',function(e){
    e.preventDefault();
    showRecoverPasswordForm();
  });

  $('#HideRecoverPasswordLink').on('click',function(e){
    e.preventDefault();
    hideRecoverPasswordForm();
  });

  if (window.location.hash.indexOf('recover') !== -1 ){
    showRecoverPasswordForm();
  }
}


function acceptCookies(){
  $('body').removeClass('show-accept-cookies');
  Cookies.set('show-accept-cookies-anna', 'true', {expires: 3650 });

}

$(function(){

  var body = document.documentElement || document.body
  if (!('grid' in body.style)) {
    body.className += ' no-grid'
  }
  /*============================================================================
    # General
    ==============================================================================*/

    var barHeight = $(".header__banner").height();
    var headerTopHeight = $(".header__top").outerHeight();
    $(window).scroll(function() {
      if($(window).width() < 1000){
        if ($(window).scrollTop() > barHeight) {
         $('body').addClass('scrolling');
         $('body.scrolling .header__banner').css("padding-bottom", headerTopHeight);
       } else {
        $('body.scrolling .header__banner').css("padding-bottom", "0");
        $('body').removeClass('scrolling');
      }
    }
  });



    /*============================================================================
    <<<<<<<< Drawers
    ==============================================================================*/

    $('.close-drawers').click(function(e){
      $('body, html').removeClass('drawer-left-open').removeClass('drawer-right-open');
    });

    $('.open-drawer').click(function(e){
      e.preventDefault();

      if($(this).data('drawer') == 'left'){
        $('body, html').removeClass('drawer-right-open').toggleClass('drawer-left-open');
      }else{
        $('body, html').removeClass('drawer-left-open').toggleClass('drawer-right-open');
      }
    });

    $('body').click(function(e){

      if(($('body').hasClass('drawer-left-open') || $('body').hasClass('drawer-right-open')) && !$(e.target).hasClass('drawer__inner') && !$(e.target).hasClass('open-drawer') && $(e.target).closest('.drawer__inner').length == 0){

        $('body').removeClass('drawer-right-open').removeClass('drawer-left-open');
        $('html').removeClass('drawer-right-open').removeClass('drawer-left-open');
      }
    });

    /*============================================================================
    # Navigation Hover
    ==============================================================================*/

    $( ".navigation .navigation-li" ).hover(
      function() {
        if ($(this).find(".submenu").length > 0) {
          $( ".main-content" ).addClass( "overlay" );
        }
        $(this).siblings().find(".navigation-li-a").addClass("second-color");
      }, function() {
        $( ".main-content" ).removeClass( "overlay" );
        $(this).siblings().find(".navigation-li-a").removeClass("second-color");
      }

      );


    /*============================================================================
    <<<<<<<< Modals
    ==============================================================================*/

    $('.modal__close').click(function(){
      $('.modal').removeClass('open');
      $('body').removeClass('modal-open');
    });

    $('.open-modal').click(function(){
      $('.modal[data-modal='+$(this).data('modal')+']').addClass('open');
      $('body').addClass('modal-open');
    });

    /*============================================================================
    # Product Page
    ==============================================================================*/
    $('.bao-selectors__header').click(function(e){
      $(this).siblings(".bao-selectors__choices").slideToggle();
      $(this).parent().toggleClass("z-index");
    });

    if($('.product-tabs').length > 0){

      $('.product-tabs .element .title-wrapper').click(function(){
        if($(this).parent().hasClass("open")){
          $(this).parent().find(".element__content").slideUp();
          $(this).parent().removeClass("open");
        }
        else{
          $('.product-tabs .element').removeClass("open").find(".element__content").slideUp();
          $(this).parent().addClass("open").find(".element__content").slideDown();
        }

      });

    }

    $(".AddToCart .text").click(function(){
      if ($(this).parent().is(":disabled")) {
        $(this).siblings(".select-tooltip").toggleClass("visible");
      }

    });


    /*============================================================================
    # Filter Modal
    ==============================================================================*/

    $('.bao-filter__title').click(function(e){
      $(this).siblings(".bao-filter-ul").slideToggle();
      $(this).find('.icon').toggle();
    });


    $('.filter-element.filter-element--sort-by').click(function(e){
      $(this).find('.filters-wrapper-sort-by').slideToggle(300);
    });

    $('.filter-element.filter-element--sort-by .filter-li').click(function(e){
      $('.filter-element.filter-element--sort-by .filter-li').removeClass('selected');
      $(this).addClass('selected');
    });



    /*============================================================================
    # Mobile Menu
    ==============================================================================*/

    $('.mobile-navigation-li--header .icon, .mobile-submenu-navigation--header .icon').click(function(){
      $(this).parent().next().slideToggle();
      $(this).parent().find(".icon").toggle();
    });

    /*============================================================================
    # FAQ
    ==============================================================================*/

    $('.faq__category').click(function(){
      $('.faq__category').removeClass('active');
      $(this).addClass('active');
      $('.faq__questions').removeClass('active');
      $('.faq__questions[data-category='+$(this).text()+']').addClass('active');
    });


    $('.faq__question').click(function(){
      $(this).parent().toggleClass('open')
    })

    /*============================================================================
    # Flickity Carousels
    ==============================================================================*/


    if($('.product-carousel__carousel').length > 0){
      $('.product-carousel__carousel').flickity({
        cellAlign: 'left',
        wrapAround: true
      });
    }

    if($('.product__images__featured--carousel .featured__image').length > 0){
      $('.product__images__featured').flickity({
        cellAlign: 'left',
        prevNextButtons: false,
        imagesLoaded: true
      });
    }

    if($('.side--carousel .side__image').length > 0){
      $('.side--carousel').flickity({
        cellAlign: 'left',
        prevNextButtons: false,
        pageDots: false,
        asNavFor: ".product__images__featured",
        imagesLoaded: true
      });
    }

    // Product zoom - Disable zoom for screensizes less than 960px i.e. touch screens
    var windowsize = $(window).width();

    if (windowsize < 960) {
      $('.image-zoom').trigger('zoom.destroy');
    } else {
      $('.image-zoom').wrap('<span style="display:inline-block"></span>').css('display', 'block').parent().zoom({
        url: $(this).find('img').attr('data-zoom')
      });
    }

    $(window).resize(function() {
      windowsize = $(window).width();
      if (windowsize < 960) {
        $('.image-zoom').trigger('zoom.destroy');
      } else {
        $('.image-zoom').wrap('<span style="display:inline-block"></span>').css('display', 'block').parent().zoom({
          url: $(this).find('img').attr('data-zoom')
        });
      }
    });

    if($('.hero-sliders--carousel .hero-slide').length > 0){
      var $heroCarousel = $('.hero-sliders--carousel');

      var carouselColor;
      var colorString1;
      var colorString2;
      var colorString3;
      var fullColorString;

      $heroCarousel.on( 'ready.flickity', function() {

        carouselColor = $(".hero-slide:first-child").attr("data-color");

        if (carouselColor) {
        }
        else{
          carouselColor = "#dde6ef";
        }

        colorString1 = "background: " + carouselColor;
        colorString2 = "background: -moz-linear-gradient(top, " + carouselColor + " 0%, " + carouselColor + " calc(100% - 100px), #fff calc(100% - 100px), #fff calc(100% - 100px), #fff 100%)";
        colorString3 = "background: -webkit-linear-gradient(top, " + carouselColor + " 0%, " + carouselColor + " calc(100% - 100px), #fff calc(100% - 100px), #fff calc(100% - 100px), #fff 100%)";
        colorString4 = "background: linear-gradient(to bottom, " + carouselColor + " 0%, " + carouselColor + " calc(100% - 100px), #fff calc(100% - 100px), #fff calc(100% - 100px), #fff 100%)";

        var fullColorString = [
        colorString1,colorString2,colorString3,colorString4
        ].join(';');

        $('.hero').attr('style', fullColorString);

      });

      $heroCarousel.flickity({
        cellAlign: 'left',
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        autoPlay: 6000,
        imagesLoaded: true
      });


      $heroCarousel.on( 'change.flickity', function( event, index ) {

        carouselColor = $(".hero-slide:nth-child("+ (index + 1) +")").attr("data-color");

        if (carouselColor) {
        }
        else{
          carouselColor = "#dde6ef";
        }

        colorString1 = "background: " + carouselColor;
        colorString2 = "background: -moz-linear-gradient(top, " + carouselColor + " 0%, " + carouselColor + " calc(100% - 100px), #fff calc(100% - 100px), #fff calc(100% - 100px), #fff 100%)";
        colorString3 = "background: -webkit-linear-gradient(top, " + carouselColor + " 0%, " + carouselColor + " calc(100% - 100px), #fff calc(100% - 100px), #fff calc(100% - 100px), #fff 100%)";
        colorString4 = "background: linear-gradient(to bottom, " + carouselColor + " 0%, " + carouselColor + " calc(100% - 100px), #fff calc(100% - 100px), #fff calc(100% - 100px), #fff 100%)";

        var fullColorString = [
        colorString1,colorString2,colorString3,colorString4
        ].join(';');

        $('.hero').attr('style', fullColorString);

      });
    }
    
    $(".flickity-page-dots").each(function(){
      $(this).append("<li class='all-dots'>of " + $(this).find(".dot").length + "</li>");

    });

  // Cookies Bar
  // Show automatically based on cookies

  // Show automatically accept cookies
  if(Cookies.get('show-accept-cookies-anna') === undefined){
    $('body').addClass('show-accept-cookies');
  }

// Try In Functionality
$("input#ContactFormDate, select#ContactFormTime, input#ContactForm2Date, select#ContactForm2Time").change(function(){
  if ($(this).val() === ""){
    $(this).addClass('unselected'); 
  } else {
    $(this).removeClass('unselected');
  }
});

var date = new Date();
var weekDay = date.getDay();
var mon = date.getMonth()+1; //January is 0!
var yr = date.getFullYear();

var daysInMonth = new Date(yr, mon, 0).getDate();

// If Friday
if (weekDay == 5) {
  var day = date.getDate() + 5;
}
else if (weekDay == 6){
  var day = date.getDate() + 4;
}
else{
  var day = date.getDate() + 3;
}

// If days are more than month, add next month

if (day > daysInMonth) {
  day -= daysInMonth;
  mon += 1;
}
if (mon > 12) {
  mon = 1;
  yr +=1;
}

day = new String(day);
mon = new String(mon);
yr = new String(yr);

if(day.length < 2) { day = "0" + day; }
if(mon.length < 2) { mon = "0" + mon; }

var dateSoonest = new String( yr + '-' + mon + '-' + day );

// + Week calculations

var dayLatest = date.getDate() + 10;
var monLatest = date.getMonth()+1;
var yrLatest = date.getFullYear();

if (dayLatest > daysInMonth) {
  dayLatest -= daysInMonth;
  monLatest += 1;
}
if (monLatest > 12) {
  monLatest = 1;
  yrLatest +=1;
}


dayLatest = new String(dayLatest);
monLatest = new String(monLatest);
yrLatest = new String(yrLatest);

if(dayLatest.length < 2) { dayLatest = "0" + dayLatest; }
if(monLatest.length < 2) { mon = "0" + mon; }

var dateLatest = new String( yrLatest + '-' + monLatest + '-' + dayLatest );

console.log(dayLatest, monLatest, yrLatest);

$("input#ContactFormDate").attr("min", dateSoonest);
$("input#ContactForm2Date").attr("min", dateSoonest);

$("input#ContactFormDate").attr("max", dateLatest);

$("select#ContactFormStore, select#ContactForm2Store").change(function(e){
    // var storeOpenTime = $(this).find(':selected').data('open-time-start');
    // var storeCloseTime = $(this).find(':selected').data('open-time-close');
    // $("#ContactFormTime").attr("min", storeOpenTime);
    // $("#ContactFormTime").attr("max", storeCloseTime);
    if ($(this).val() === ""){

      $(this).addClass('unselected'); 
    } else {
      $(this).removeClass('unselected');
    }

  });


$("input#ContactFormDate, input#ContactForm2Date").change(function(e){

  var warning = 'Sorry, but booking is not available in weekends';
  var d = new Date(e.target.value);
  if(d.getDay() === 0) {
    $('#tryInSubmit1, #tryInSubmit2').attr('disabled',true)
    alert(warning)
  } else {
    $('#tryInSubmit1, #tryInSubmit2').attr('disabled',false);
  }

});


$("select#ContactForm2Personalstyle").change(function(e){
  if ($(this).val() === "Other"){
    $('#personalStyleOther').slideDown().find('input').attr('required', 'required').removeAttr('disabled'); 
  } else {
    $('#personalStyleOther').slideUp().find('input').removeAttr('required').attr('disabled', 'disabled');
  }

});




function tryInModal(){
  var prodHtmlDisplay = "";
  var prodHtml = "";
  var prodVendor;
  var prodTitle;
  var prodVariant;
  var prodQuantity;
  var prodInfo;
  var prodInfoDisplay;
  var counter = 0;
  $(".ajaxcart__inner .ajaxcart__row").each(function(){
    counter += 1;
    if ($(this).find(".ajaxcart__product-vendor").length > 0) {
      prodVendor = $(this).find(".ajaxcart__product-vendor").text();
    }
    else {
      prodVendor = ""
    }

    if ($(this).find(".ajaxcart__product-name").length > 0) {
      prodTitle = $(this).find(".ajaxcart__product-name").text();
    }
    else {
      prodTitle = ""
    }
    if ($(this).find(".ajaxcart__product-variation").length > 0) {
      prodVariant =" - (" + $(this).find(".ajaxcart__product-variation").text() + ")";
    }
    else {
      prodVariant = ""
    }
    if ($(this).find(".ajaxcart__product-qty").length > 0) {
      prodQuantity =" " + $(this).find(".ajaxcart__product-qty").text();
    }
    else {
      prodQuantity = ""
    }

    prodInfo = prodVendor + " - " + prodTitle + prodVariant + prodQuantity + "\n";
    prodInfoDisplay = counter + ". " + prodVendor + " - " + prodTitle + prodVariant + "<br>";
    prodHtml += prodInfo;
    prodHtmlDisplay += prodInfoDisplay;

  });
  $(".modal[data-modal='try-in-modal']").find(".modal__content textarea#ContactFormMessage").val(prodHtml);
  $(".modal[data-modal='try-in-modal']").find(".try-in__products").html(prodHtmlDisplay);


    if ( document.location.href.indexOf('contact_posted=true#contact_form') > -1 ) {
      $('.modal[data-modal="thanks-contacting-us"]').addClass("open");
    }

  }

  jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt){
    tryInModal();
    $('.open-modal[data-modal="try-in-modal"]').click(function(){
      $('.modal[data-modal='+$(this).data('modal')+']').addClass('open');
      $('body').addClass('modal-open');
    });
  });

  jQuery(document.body).on('completeAddItem.ajaxCart', function(evt){
    tryInModal();
  });


});
